import TEMPLATE_URL from "emun.order/picker/order-picker.htm";
import controller from "emun.order/picker/order-picker.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "xl",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  placement = undefined, // "right",
  title = "Select order(s)...",
  subTitle = "Add to order list",
  view = "table",
  single = false,
  viewSelections = false,
  okButtonText = "OK",
  closeButtonText = single ? "Close" : "Cancel",
  selected = {},
  criteria = {},
  onToggle = NOOP,
  onOrderSelected = NOOP,
  onOrderDeselected = NOOP
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    console: console.debug(templateUrl, {
      placement,
      size,
      backdrop,
      title,
      view
    }),
    placement,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        subTitle,
        onOrderSelected,
        onOrderDeselected,
        onToggle,
        criteria,
        view,
        viewSelections,
        okButtonText,
        closeButtonText,
        single,
        selected
      })
    }
  }).result;
